import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import {
  InputForm,
  SelectFormm,
  TextAreaForm,
} from "../../components/molecules/forms/index";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import DetailDataSkeleton from "../../components/template/skeleton/DetailDataSkeleton";
import WarningIcon from "@mui/icons-material/Warning";
import Swal from "sweetalert2";
import { renderToStaticMarkup } from "react-dom/server";
import userAccount from "../../utils/validation/userAccount";
import {
  useCreateUserAccMutation,
  useUpdateUserAccMutation,
} from "../../store/feature/service/UserAccountApiSlice";
import userAccountUpdate from "../../utils/validation/userAccountUpdate";
import { useRoleListQuery } from "../../store/feature/service/adminRole";
import { encrypt } from "../../utils/hash/password";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { createCompany } from "../../utils/validation/company";
import {
  useCreateCmpnyMutation,
  useGetCompListDetailMutation,
  useUpdateCmpnyMutation,
} from "../../store/feature/service/companyApiSlice";

const CompanyField = () => {
  // REGION: INIT VARIABLES
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const idParam = useParams();
  const { pathname, state } = location;
  const editFgroup = pathname.includes("edit");
  const [optAccGroup, setOtpAccGroup] = useState([]);
  const [isShowPass, setIsShowPass] = useState(false);
  const [isShowConfirmPass, setIsShowConfirmPass] = useState(false);

  const {
    data: dataRoleList,
    isError: errRoleList,
    isSuccess: succRoleList,
  } = useRoleListQuery({});

  const [
    GetCpnDetail,
    {
      data: dataGetCpnDetail,
      isError: isErrorGetCpnDetail,
      isSuccess: isSuccesGetCpnDetail,
    },
  ] = useGetCompListDetailMutation();
  const [
    CreateCompany,
    {
      data: dataCreateCompany,
      isError: isErrorCreateCompany,
      isSuccess: isSuccesCreateCompany,
    },
  ] = useCreateCmpnyMutation();

  // useUpdateDACertMutation
  const [
    UpdateCmpny,
    {
      data: dataUpdateCmpny,
      isError: isErrorUpdateCmpny,
      isSuccess: isSuccesUpdateCmpny,
    },
  ] = useUpdateCmpnyMutation();
  // REGION: INIT FORM DATA
  const {
    control,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<{
    cpnName: string;
    cpnEmail: string;
    industry: string;
    address: string;
    description: string;
    cpnPhone: string;
    PICname: string;
    PICemail: string;
    PICposition: string;
    PICphone: string;
    PICremarks: string;
    cpnRegNum: string;
    cpnVAT: string;
    status: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(createCompany),
    defaultValues: {
      cpnName: "",
      cpnEmail: "",
      industry: "",
      address: "",
      description: "",
      cpnPhone: "",
      PICname: "",
      PICemail: "",
      PICposition: "",
      PICphone: "",
      PICremarks: "",
      cpnRegNum: "",
      cpnVAT: "",
      status: "",
    },
  });

  useEffect(() => {
    if (editFgroup) {
      GetCpnDetail(idParam.id);
      // console.log('idParam ===> ', idParam);
    }
  }, []);

  useEffect(() => {
    if (dataGetCpnDetail) {
      console.log("dataGetCpnDetail ===> ", dataGetCpnDetail);
      setValue("cpnName", dataGetCpnDetail?.data.cpn_name);
      setValue("cpnEmail", dataGetCpnDetail?.data.cpn_email);
      setValue("industry", dataGetCpnDetail?.data.cpn_industry);
      setValue("address", dataGetCpnDetail?.data.cpn_address);
      setValue("description", dataGetCpnDetail?.data.cpn_description);
      setValue("cpnPhone", dataGetCpnDetail?.data.cpn_phone_number);
      setValue("PICname", dataGetCpnDetail?.data.cpn_pic1name);
      setValue("PICemail", dataGetCpnDetail?.data.cpn_pic1email);
      setValue("PICposition", dataGetCpnDetail?.data.cpn_pic1position);
      setValue("PICphone", dataGetCpnDetail?.data.cpn_pic1phone1);
      setValue("PICremarks", dataGetCpnDetail?.data.cpn_pic1remarks);
      setValue("cpnRegNum", dataGetCpnDetail?.data.cpn_registrationnbr);
      setValue("cpnVAT", dataGetCpnDetail?.data.cpn_vatnbr);
      setValue("status", dataGetCpnDetail?.data.cpn_status);
    }
  }, [dataGetCpnDetail]);

  // REGION: DISPATCH INSERT & UPDATE DATA

  const onSubmit = async (e: any) => {
    console.log("form data ===> ", e);
    let create = {
      cpn_name: e.cpnName,
      cpn_email: e.cpnEmail,
      cpn_industry: e.industry,
      cpn_address: e.address,
      cpn_description: e.description,
      cpn_phone_number: e.cpnPhone,
      cpn_pic1name: e.PICname,
      cpn_pic1email: e.PICemail,
      cpn_pic1position: e.PICposition,
      cpn_pic1phone1: e.PICphone,
      cpn_pic1remarks: e.PICremarks,
      cpn_registrationnbr: e.cpnRegNum,
      cpn_vatnbr: e.cpnVAT,
      cpn_status: e.status,
    };

    if (editFgroup) {
      Swal.fire({
        title: "Update Confirmation",
        text: "Are you sure you want to Update Company?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#808080",
        confirmButtonText: "Yes",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await UpdateCmpny({ uid: idParam.id, params: create });
        }
      });
    } else {
      Swal.fire({
        title: "Submit Confirmation",
        text: "Are you sure you want to Create Company?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#808080",
        confirmButtonText: "Yes",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await CreateCompany(create);
        }
      });
    }
  };

  const showFirstAlert = () => {
    Swal.fire({
      title: "Your changes won’t be saved",
      html: `
            <p style="text-align: left;">
              We won’t be able to save your data if you move away from this page.
            </p>
          `,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808080",
      iconHtml: renderToStaticMarkup(
        <WarningIcon style={{ fontSize: "50px", color: "#d33" }} />
      ),
      confirmButtonText: "Discard Data",
      cancelButtonText: "Go back",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        navigate("/company");
      }
    });
  };

  const handleRevoke = (e: any) => {
    console.log("handle revoke ===> ");
    showFirstAlert();
  };

  const optStatusSelect = [
    {
      label: "ACTIVE",
      value: "active",
    },
    {
      label: "INACTIVE",
      value: "inactive",
    },
  ];

  useEffect(() => {
    if (dataRoleList) {
      setOtpAccGroup(
        dataRoleList?.data.map((item: any) => ({
          label: item.adm_role_name,
          value: item.adm_role_uid,
        }))
      );
    }
  }, [dataRoleList]);

  useEffect(() => {
    if (isSuccesCreateCompany) {
      Swal.fire({
        icon: "success",
        title: "Success Create",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Success Create Company",
      }).then(() => navigate("/company"));
    }
  }, [isSuccesCreateCompany]);

  useEffect(() => {
    if (isErrorCreateCompany) {
      Swal.fire({
        icon: "error",
        title: "Error Create",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Error Create Company",
      });
    }
  }, [isErrorCreateCompany]);

  useEffect(() => {
    if (isSuccesUpdateCmpny) {
      Swal.fire({
        icon: "success",
        title: "Success Update",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Success Update Company ",
      }).then(() => navigate("/company"));
    }
  }, [isSuccesUpdateCmpny]);

  useEffect(() => {
    if (isErrorUpdateCmpny) {
      Swal.fire({
        icon: "error",
        title: "Error Update",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Error Update Company",
      });
    }
  }, [isErrorUpdateCmpny]);

  // REGION: RETURN TSX
  return (
    <DetailDataSkeleton
      // isLoading={isLoadingOcspConfig}
      // isLoadingEvent={isLoadingEvent}
      inputCount={6}
      titleWidth={"350px"}
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)} paddingY="20px">
        <Grid container spacing={1}>
          <Grid item sm={12} md={12} lg={12}>
            <Typography variant="h3" fontFamily="Open Sans" mb={3}>
              {editFgroup ? "Update Company" : "Create Company"}
            </Typography>
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="cpnName"
              label="Company Name"
              placeholder="Type First Name"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="cpnEmail"
              label="Company Email"
              placeholder="Type Company Email"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextAreaForm
              name="address"
              label="Address"
              placeholder="Type Address"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
              defaultValue={""}
            />
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextAreaForm
              name="description"
              label="Description"
              placeholder="Type Description"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              defaultValue={""}
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="industry"
              label="Industry"
              placeholder="Type Industry"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <SelectFormm
              name="status"
              label="Status"
              defaultValue={0}
              options={optStatusSelect}
              placeholder="none"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="cpnPhone"
              label="Company Phone"
              placeholder="Type Company Phone"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              type="number"
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="PICname"
              label="PIC Name"
              placeholder="Type PIC Name"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="PICemail"
              label="PIC Email"
              placeholder="Type PIC Email"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="PICposition"
              label="PIC Position"
              placeholder="Type PIC Position"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="PICphone"
              label="PIC Phone"
              placeholder="Type PIC Phone"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              type="number"
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="PICremarks"
              label="PIC Remarks"
              placeholder="Type PIC Remarks"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="cpnRegNum"
              label="Company Reg Number"
              placeholder="Type Company Reg Number"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              type="number"
              required
            />
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <InputForm
              name="cpnVAT"
              label="Company VAT"
              placeholder="Type Company VAT"
              disabled={false}
              isLoading={false}
              control={control}
              errors={errors}
              maxLength={500}
              required
            />
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                variant="contained"
                type="button"
                color="gray"
                onClick={handleRevoke}
              >
                Cancel
              </Button>
              <Button variant="contained" type="submit">
                {editFgroup ? "Update" : "Submit"}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </DetailDataSkeleton>
  );
};

export default CompanyField;
